import Nullstack from 'nullstack';
export default function IconPerfume({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-perfume",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 6v3"
  }), "   ", Nullstack.element("path", {
    d: "M14 6v3"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "9",
    width: "14",
    height: "12",
    rx: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "15",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M9 3h6v3h-6z"
  }), " ");
}